import React, { useState } from "react";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";
import { PRODUCT_IDS } from "utils/constants";
import { Loading } from "components/common";
import ManageTrackedAccountOpen from "./ManageTrackedAccountsOpen";

const REMOVE_ACCOUNT_TRACKING_GQL = gql`
  mutation removeAccountProductVisibility(
    $uuids: [String!]
    $product_id: String!
  ) {
    removeAccountProductVisibility(uuids: $uuids, product_id: $product_id) {
      status
      code
      message
    }
  }
`;

const ADD_ACCOUNT_TRACKING_GQL = gql`
  mutation addAccountProductVisibility(
    $uuids: [String!]
    $product_id: String!
  ) {
    addAccountProductVisibility(uuids: $uuids, product_id: $product_id) {
      status
      code
      message
    }
  }
`;

const ManageTrackedAccounts = ({
  user,
}) => {
  const [removeAccountTrackingAPI] = useMutation(REMOVE_ACCOUNT_TRACKING_GQL);
  const [addAccountTrackingAPI] = useMutation(ADD_ACCOUNT_TRACKING_GQL);
  const [loading, setLoading] = useState(false);

  const userBankAccounts = (user.boost.accounts || [])
    .reduce((acc, bank) => {
      const { institutionName, logoURL, accounts } = bank;
      const accountsWithBankData = accounts.map((a) => ({ ...a, institutionName, logoURL }));
      acc.push(...accountsWithBankData);
      return acc;
    }, [])
    .sort((a, b) => {
      // sort by last updated
      const timeA = a.statusCodeUpdatedAt ? new Date(a.statusCodeUpdatedAt).getTime() : 0;
      const timeB = a.statusCodeUpdatedAt ? new Date(b.statusCodeUpdatedAt).getTime() : 0;
      return timeB - timeA;
    });

  const removeAccountTracking = async (uuids) => {
    setLoading(true);
    const payload = {
      uuids,
      product_id: PRODUCT_IDS.CREDIT_BOOST,

    };
    await removeAccountTrackingAPI({ variables: payload }).then((response) => {
      console.log(response.data.removeAccountProductVisibility.status);
      if (response.data.removeAccountProductVisibility.status === `SUCCESS`) {
        // if successful, lets just change the data here instead of reloading
        const account = userBankAccounts.filter((ua) => uuids.includes(ua.uuid));
        account.forEach((acc) => {
          const idx = acc.appliedProducts.indexOf(PRODUCT_IDS.CREDIT_BOOST);
          if (idx !== -1) {
            acc.appliedProducts.splice(idx, 1);
          }
        });
        setLoading(false);
      } else {
        // todo show error
        setLoading(false);
      }
    }).catch(() => {
      // do something with error maybe show it;
      setLoading(false);
    });
  };

  const addAccountTracking = async (uuids) => {
    setLoading(true);
    const payload = {
      uuids,
      product_id: PRODUCT_IDS.CREDIT_BOOST,
    };
    await addAccountTrackingAPI({ variables: payload }).then((response) => {
      if (response.data.addAccountProductVisibility.status === `SUCCESS`) {
        // if successful, lets just change the data here instead of reloading
        const account = userBankAccounts.filter((ua) => uuids.includes(ua.uuid));
        account.forEach((acc) => {
          acc.appliedProducts.push(PRODUCT_IDS.CREDIT_BOOST);
        });
        setLoading(false);
      } else {
        // todo show error
        setLoading(false);
      }
    }).catch(() => {
      setLoading(false);
    });
  };

  if (loading) {
    return (<Loading boost />);
  }

  return (
    <ManageTrackedAccountOpen
      accounts={userBankAccounts}
      removeAccountTracking={removeAccountTracking}
      addAccountTracking={addAccountTracking}
    />
  );
};

export default ManageTrackedAccounts;